import { Constants } from '../_constants/shared.constants';
const initialState = {};
function loginReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.login.LOGIN_SUCCESS:
      return {
        ...state,
        user: action.data,
      };
    case Constants.login.LOGIN_FAILURE:
      return {
      };
    default:
      return state
  }
}
export default loginReducer;